import type { ReactNode } from 'react'
import { useState } from 'react'

import { faGavel } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedNumber } from 'react-intl'
import { styled } from 'styled-components'

import { FormattedMessage, Tooltip } from '@b-stock/fe-core/bstock-react'

import { useBidFormContext } from '@/buyer-portal/components/features/listing/actions/auction/BidFormProvider'
import { usePermission, PermissionGranule } from '@/helpers/permissions'

import { StatButton } from './Stat'

const WhiteLink = styled.a`
  color: white;
  text-decoration: underline;
`

const StyledTooltip = styled(Tooltip)`
  pointer-events: initial;
  white-space: pre-line;
`

export const BidCount = ({
  displayAsBuyNow,
  openStatisticModal,
}: {
  displayAsBuyNow?: boolean
  openStatisticModal?: () => void
}) => {
  const {
    details: { bidCount },
  } = useBidFormContext()

  const canViewAuctionStatistics = usePermission(
    PermissionGranule.FEBP_LISTING_DETAIL_AUCTION_STATS
  )

  const [ref, setRef] = useState<HTMLButtonElement | null>(null)

  if (
    typeof bidCount === 'undefined' ||
    !canViewAuctionStatistics ||
    displayAsBuyNow
  ) {
    return null
  }

  return (
    <>
      <StatButton type="button" onClick={openStatisticModal} ref={setRef}>
        <FontAwesomeIcon icon={faGavel} />
        <span data-testid="stats-bidCount">
          <FormattedNumber value={bidCount} />
        </span>
      </StatButton>

      {ref ? (
        <StyledTooltip referenceElement={ref} containerElement={ref}>
          <FormattedMessage
            id={`Auction.details.statsBar.tooltip.bids`}
            values={{
              bids: bidCount,
              viewBidHistoryLink: (chunks: ReactNode) => (
                <WhiteLink onClick={openStatisticModal}>{chunks}</WhiteLink>
              ),
            }}
          />
        </StyledTooltip>
      ) : null}
    </>
  )
}
